import $ from "jquery"
import modalImageTemplate from "../../../views/content/modals/modalImage.html"

export default class ModalImage {
  constructor() {}

  /**
   *  Registers all events related to the image modals
   *  @returns {void}
   */
  registerEventListeners() {
    // Listen for a image icon click
    $("body").on("click", ".material-icons.image", this.openImageModal)
  }

  /**
   * Open image modal
   * This function should be called from an event containing a img-url in the element called from
   * @private
   * @returns {void}
   */
  openImageModal() {
    let html = modalImageTemplate.render({
      image: $(this).attr("img-url"),
      translations: window.session.translations,
    })
    window.largeModalInstance.setContent(html)
    window.largeModalInstance.update()
    window.largeModalInstance.show()
  }
}
